//
// Game
//
// Plumbs components together once they have all loaded

game = {};
gameData = {};
gameData.gameName = "Big Game Fishing Christmas Catch";
gameData.gameVersionMajor = "1";
gameData.gameVersionMinor = "0";
gameData.gameVersionBugFix = "3";
gameData.gameReleaseDate = "14/11/2025"; // update me upon release

gameData.symbolWidth = 192;
gameData.symbolHeight = 162;
gameData.appertureSize = 162;
gameData.numReels = 5;
gameData.numRows = 3;
game.buttonPositionsLandscape = [];
game.buttonPositionsPortrait = [];
game.configTask = undefined;

gameData.themeTuneId = undefined;
gameData.freespinsThemeTuneId = undefined;
gameData.mainTunePlaying = false;
game.sideMenuOpen = false;

gameData.buyBonus = false;

gameData.convertStringToSegmentId = function (str) {
  switch (str) {
    case "segmentGreen": {
      return gameData.segmentDollar;
    }
    case "segmentYellow": {
      return gameData.segmentBigWin;
    }
    case "segmentBlue": {
      return gameData.segmentBonus;
    }
    case "segmentRed": {
      return gameData.segmentFreespins;
    }
    case "fsSegmentMega": {
      return gameData.fsSegmentMega;
    }
    case "fsSegmentSuper": {
      return gameData.fsSegmentSuper;
    }
    case "fsSegmentMidi": {
      return gameData.fsSegmentMidi;
    }
    case "fsSegmentMinor": {
      return gameData.fsSegmentMinor;
    }
    case "fsSegmentMini": {
      return gameData.fsSegmentMini;
    }
    case "fsSegment3Fs": {
      return gameData.fsSegment3Fs;
    }
    case "fsSegment5Fs": {
      return gameData.fsSegment5Fs;
    }
    case "fsSegment8Fs": {
      return gameData.fsSegment8Fs;
    }
    default: {
      console.log("");
    }
  }
};

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

Reflex.enableDeveloperMode();
//Reflex.developerModeData.createTestLanguages = true;
//Reflex.developerModeData.highlightTranslatedText = true;

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;
  gameData.creditMeter.set(creditTask.data.balance);
};

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    " v" +
    gameData.gameVersionMajor +
    "." +
    +gameData.gameVersionMinor +
    "." +
    gameData.gameVersionBugFix;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;

  // Set initial state
  resourceManager.getController("inputOverlord").setState("enabled");

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer("gameContainer").visible = false;
  resourceManager.getContainer("DemoContainer").visible = false;
  resourceManager.getContainer("gameButtonContainer").visible = false;

  game.configTask = gameConfigTask.data.slotConfig;

  gameData.stakes = [];
  gameData.coinSizes = [];
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );
  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;
  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(
      gameConfigTask.data.slotConfig.coinSizes[i] *
        gameConfigTask.data.slotConfig.defaultNumLines
    );
    gameData.coinSizes.push(gameConfigTask.data.slotConfig.coinSizes[i]);
  }

  gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

  gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  gameData.winningsMeterTitle = resourceManager.get(
    "meterContainer:winnings:title"
  );

  messageBus.subscribe("common:BalanceEvent", game.onCreditChanged);
  messageBus.subscribe("game:modal", game.modal);
  messageBus.subscribe("game:sideMenuOpen", game.sideMenuOpenMsg);
  messageBus.subscribe("game:sideMenuClosed", game.sideMenuClosedMsg);
  Reflex.registerEventHandler("orientationChange", game.onOrientationChange);
  Reflex.registerEventHandler("resize", game.onResize);
  messageBus.subscribe("game:backFromReplay", game.backFromReplay);

  gameController.initialise(gameConfigTask);

  game.createLogoSpine();

  // Kick off the game
  game.onOrientationChange();
  gameController.start();
};

game.createLogoSpine = function () {
  const cont = resourceManager.get("logoContainer:spineContainer");

  game.logoSplash = resourceManager.createObject("spine", "LogoSpine", cont, {
    name: "LogoSpine",
    defaultAnimation: "Logo Idle (Stacked)",
    scaleX: 1,
    scaleY: 1,
  });

  game.logoSplash.play("Logo Idle (Stacked)", true, 0, () => {});
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }

  if (game.splashScreenDone) {
    if (layoutController.getCurrentLayout() === "landscape_default") {
      for (let i = 0; i < game.buttonPositionsLandscape.length; i++) {
        const obj = game.buttonPositionsLandscape[i];

        obj.button.x = obj.position.x;
        obj.button.y = obj.position.y;
      }
    }

    if (
      layoutController.getCurrentLayout() === "portrait_default" ||
      layoutController.getCurrentLayout() === "portrait_mobile"
    ) {
      for (let i = 0; i < game.buttonPositionsPortrait.length; i++) {
        const obj = game.buttonPositionsPortrait[i];

        obj.button.x = obj.position.x;
        obj.button.y = obj.position.y;
      }
    }
  }
};

game.disableSplashBackgrounds = function (background, portrait_background) {
  background.visible = false;
  background.interactive = false;
  background.on("mouseup", function () {});
  background.on("touchend", function () {});
  portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on("mouseup", function () {});
  portrait_background.on("touchend", function () {});
};

game.onCloseTutorial = function () {
  const bgContainer = resourceManager.getContainer("backgroundContainer");
  bgContainer.visible = true;
  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.lineStyle(0, 0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);

  let license = gameData.license;

  if (license === "" || license === undefined) {
    license = "default";
  } else {
    license = gameData.license.toUpperCase();
  }

  if (license === "BR") {
    resourceManager.get("helpPageScrollContainer:helpPageScroll").open();
  }

  systemData.gameContainer.mask = gameData.gameMask;

  if (gameData.recoveryStake) {
    gameData.stakeMeter.set(gameData.recoveryStake);
  }

  game.goToGame();
};

game.goToSplash = function () {
  if (!gdk.getPlatformAllowsSplashScreen()) {
    Reflex.updateViewport();
    return;
  }

  const duration = 1.6;
  const min = 0.97;
  const max = 1.03;
  const delay = 1;
  const cont1 = resourceManager.get("SSPanelPos1");
  const cont2 = resourceManager.get("SSPanelPos2");

  cont1.scale.x = min;
  cont1.scale.y = min;
  cont2.scale.x = max;
  cont2.scale.y = max;

  gameData.timeLine1 = gsap
    .timeline({ repeat: -1 })
    .call(() => {
      cont1.scale.x = min;
      cont1.scale.y = min;
    })
    .to(cont1.scale, {
      duration,
      delay,
      x: max,
      y: max,
      ease: "power2.out",
    })
    .to(cont1.scale, {
      duration,
      delay,
      x: min,
      y: min,
      ease: "power2.out",
    });

  gameData.timeLine2 = gsap
    .timeline({ repeat: -1 })
    .call(() => {
      cont2.scale.x = max;
      cont2.scale.y = max;
    })
    .to(cont2.scale, {
      duration,
      delay,
      x: min,
      y: min,
      ease: "power2.out",
    })
    .to(cont2.scale, {
      duration,
      delay,
      x: max,
      y: max,
      ease: "power2.out",
    });
};

game.goToGame = function () {
  if (gdk.deviceInfo.chrome) {
    var chromeVersion = Number(
      String(gdk.deviceInfo.version).substring(
        0,
        String(gdk.deviceInfo.version).indexOf(".")
      )
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  if (gameData.recoveryStake) {
    game.changeStake(gameData.recoveryStake);
    resourceManager
      .getController("stakeController")
      .requestChangeStake(gameData.recoveryStake);
    gameData.currentStakeIndex = game.configTask.coinSizes.indexOf(
      gameData.recoveryStake / game.configTask.coins
    );

    if (game.configTask.recoverGB) {
      resourceManager
        .get("buttonContainer:buttonBar:luckyBetToggleButton")
        .setRecovery();
      gameData.encoreEnabled = true;
    }
  } else {
    game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
  }

  gameData.timeLine1?.pause();
  gameData.timeLine2?.pause();

  game.splashScreenDone = true;

  game.slideShowActive = false;

  timerManager.stop(game.slideshowTimer);

  gameData.mainTunePlaying = true;

  resourceManager.getContainer("loadingContainer").visible = false;
  resourceManager.getContainer("gameContainer").visible = true;
  resourceManager.getContainer("msgBoxPopupContainer").visible = true;
  resourceManager.getContainer("gameButtonContainer").visible = true;
  resourceManager.getContainer("particleContainer").visible = true;
  resourceManager.getContainer("buyABonusContainer").visible = true;
  resourceManager.getContainer("settingsMenuContainer").visible = true;
  resourceManager.getContainer("florishContainer").visible = true;
  resourceManager.getContainer("splashContainer").visible = false;
  resourceManager.getContainer("loadingContainer").visible = false;
  resourceManager.get("maxWinPopup").visible = false;
  resourceManager.getContainer("helpPageScrollContainer").visible = true;

  gameData.helpPageScroll = resourceManager.get(
    "helpPageScrollContainer:helpPageScroll"
  );
  gameData.winningsText = resourceManager.get("winningsText");
  game.loadingBackgroundLandscape = resourceManager.get("splashBackgroundL");
  game.loadingBackgroundLandscape.clearInteractiveCallbacks();
  game.loadingBackgroundPortrait = resourceManager.get("splashBackgroundP");
  game.loadingBackgroundPortrait.clearInteractiveCallbacks();

  resourceManager.getContainer("DemoContainer").visible = true;

  game.getButtonPositions();

  game.onResize();

  game.onOrientationChange();

  //game.overrideButtons();
  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.inRecovery) {
    gameController.initNewGame();
  }
};

game.getButtonPositions = function () {
  const allowGamble = gdk.getPlatformAllowsGamble();
  const allowBuyBonus = gdk.getPlatformAllowsBuyBonus();
  const allowLucky = gdk.getPlatformAllowsUpstake();

  const maxPlay = resourceManager.get(
    "buttonContainer:buttonBar:maxPlayButton"
  );
  const buyBonus = resourceManager.get(
    "buttonContainer:buttonBar:buyBonusButton"
  );
  const gambleMode = resourceManager.get(
    "buttonContainer:buttonBar:gambleModeButton"
  );
  const luckyBet = resourceManager.get(
    "buttonContainer:buttonBar:luckyBetToggleButton:button"
  );

  let buttons = [];

  buttons.push(maxPlay);

  if (allowBuyBonus) {
    buttons.push(buyBonus);
  }
  if (allowGamble) {
    buttons.push(gambleMode);
  }
  if (allowLucky) {
    buttons.push(luckyBet);
  }

  const positionsLandscape = [
    { x: 1210, y: -155 },
    { x: 1210, y: -400 },
  ];

  const positionsPortrait = [
    [{ x: 359, y: 904 }],
    [
      { x: 135, y: 1040 },
      { x: 583, y: 1040 },
    ],
    [
      { x: 135, y: 1040 },
      { x: 359, y: 904 },
      { x: 583, y: 1040 },
    ],
    [
      { x: 135, y: 1040 },
      { x: 255, y: 904 },
      { x: 460, y: 900 },
      { x: 583, y: 1040 },
    ],
  ];

  for (let i = 0; i < buttons.length; i++) {
    const obj = {
      button: buttons[i],
      position: positionsPortrait[buttons.length - 1][i],
    };

    game.buttonPositionsPortrait.push(obj);

    if (buttons.length === 2) {
      const obj = {
        button: buttons[i],
        position: positionsLandscape[i],
      };

      game.buttonPositionsLandscape.push(obj);
    }
  }
};

game.overrideButtons = function () {
  game.addNonNumpadSpeedControl();

  const uiName = "uiContainer:bg";

  // const slamStopButton = resourceManager.get(uiName + ":slamStopButton");
  // slamStopButton.canEnableBase = slamStopButton.canEnable;
  // slamStopButton.canEnable = function(){
  //     return slamStopButton.canEnableBase() && !gameController.spinComplete && gameData.reelsSpinning > 0 && gameController.canSlamStop;
  // };
  // const slamStopButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:slamStopButton_portrait");
  // slamStopButtonPortrait.canEnableBase = slamStopButtonPortrait.canEnable;
  // slamStopButtonPortrait.canEnable = function(){
  //     return slamStopButtonPortrait.canEnableBase() && !gameController.spinComplete && gameData.reelsSpinning > 0 && gameController.canSlamStop;
  // };

  const autoplayController =
    resourceManager.getController("autoplayController");

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play("buttonPressed");
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play("buttonPressed");
    }
    baseCancel();
  };

  const spinButton = resourceManager.get("uiContainer:bg:spinButton");
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return (
      this.canEnableBase() &&
      /*!settingsMenu.container.visible &&*/ !helpPageManager.container
        .visible &&
      !game.sideMenuOpen
    );
  };
  const spinButtonPortrait = resourceManager.get(
    "buttonContainerMobile:reflexButtonBar:spinButton_portrait"
  );
  spinButtonPortrait.canEnableBase = spinButtonPortrait.canEnable;
  spinButtonPortrait.canEnable = function () {
    return (
      this.canEnableBase() &&
      /*!settingsMenu.container.visible &&*/ !helpPageManager.container
        .visible &&
      !game.sideMenuOpen
    );
  };

  const autoplayButton = resourceManager.get("uiContainer:bg:autoplayButton");
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const autoplayButtonPortrait = resourceManager.get(
    "buttonContainerMobile:reflexButtonBar:autoplayButton_portrait"
  );
  autoplayButtonPortrait.baseCanEnable = autoplayButtonPortrait.canEnable;
  autoplayButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const stakeButton = resourceManager.get("uiContainer:bg:stake");
  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const stakeButtonPortrait = resourceManager.get(
    "buttonContainerMobile:reflexButtonBar:stake_portrait"
  );
  stakeButtonPortrait.baseCanEnable = stakeButtonPortrait.canEnable;
  stakeButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const volumeButton = resourceManager.get("uiContainer:bg:volume");
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
};

game.modal = function (task) {
  if (task.reason === "autoplay") {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === "") {
    game.autoplayPopupOpen = false;
  }
};

game.addNonNumpadSpeedControl = function () {
  if (gdk.isDevelopmentBuild()) {
    Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
      if (!Reflex.developerModeData.manipulateCredit) {
        switch (keycode) {
          case 32: {
            // Pause/break key
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 48: {
            // Keypad 0
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 49: {
            // Keypad 1
            Reflex.developerModeData.speedModifier = 0.0625;
            break;
          }
          case 50: {
            // Keypad 2
            Reflex.developerModeData.speedModifier = 0.125;
            break;
          }
          case 51: {
            // Keypad 3
            Reflex.developerModeData.speedModifier = 0.25;
            break;
          }
          case 52: {
            // Keypad 4
            Reflex.developerModeData.speedModifier = 0.5;
            break;
          }
          case 53: {
            // Keypad 5
            Reflex.developerModeData.speedModifier = 1.0;
            break;
          }
          case 54: {
            // Keypad 6
            Reflex.developerModeData.speedModifier = 2.0;
            break;
          }
          case 55: {
            // Keypad 7
            Reflex.developerModeData.speedModifier = 4.0;
            break;
          }
          case 56: {
            // Keypad 8
            Reflex.developerModeData.speedModifier = 8.0;
            break;
          }
          case 57: {
            // Keypad 9
            Reflex.developerModeData.speedModifier = 16.0;
            break;
          }
          case 58: {
            // * key
            Reflex.developerModeData.speedModifier += 0.05;
            break;
          }
          case 59: {
            // / Key
            Reflex.developerModeData.speedModifier -= 0.05;
            break;
          }
          default:
            break;
        }

        if (Reflex.developerModeData.speedModifier > 256)
          Reflex.developerModeData.speedModifier = 256;
        if (Reflex.developerModeData.speedModifier < 0.00390625)
          Reflex.developerModeData.speedModifier = 0.00390625;

        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
        PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
      }
    });
  }
};

game.changeStake = function (stake) {
  gameData.stakeMeter.set(stake);
  gdk.playerChangedStake(stake);
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {
  helpPageManager.showPopup(game.onHelpPagesClosed);
};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.onAutoplayButtonPressed = function () {
  // If autoplay is running, cancel
  if (autoplayManager.isAutoplayEnabled()) {
    if (gameController.state === "WAITING_FOR_AUTOPLAY") {
      soundManager.play(gameData.sounds.autoplayCancel);
    } else {
      // We are autoplaying, so wait for autoplay to complete before enabling buttons
      gameData.autoplayButton.enableButton(false);
    }

    autoplayManager.stopAutoplay();
    gameController.cancelAutoplay();

    return;
  }

  // If we are in a waiting state, pop up the auto play interface
  if (gameController.state === "WAITING_FOR_START") {
    soundManager.play(gameData.sounds.autoplayPress);
    autoplayManager.openDialog(
      game.onAutoplayDialogConfirmed,
      game.onAutoplayDialogCancelled,
      gameData.coinSizes[gameData.currentStakeIndex],
      10
    );
  }
};

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post("sounds:restorePreviouslyPlayingAudio", {
      reason: "back from replay",
    });
  }
};
